module.exports = __webpack_public_path__ + "52324f4d7cfcdcb9f5c1324cc3df0dae.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/icon-cart-1.svg
// module id = ./assets/images/header/icon-cart-1.svg
// module chunks = 0